import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientproductApiController from "services/clientproducts.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
import { beginClientHistoryRequest, ownsClientHistoryRequest } from "./clientHistoryOwnership";

export const ClientproductApi = createAsyncThunk("clientproduct/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientproductApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  listClientId: null,
  listQueryKey: null,
  listRequestId: null,
  isListView: [],
  isListViewError: "",
  isClientDetailToSale: "",
  isApiStatus: {
    ClientproductApi: "",
  },
};

const clientproductSlice = createSlice({
  name: "clientproduct",
  initialState,
  reducers: {
    reset: () => initialState,
    clienttosaleproduct: (state, action) => {
      state.isClientDetailToSale = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('sale/StartNewInvoice', (state) => { state.isClientDetailToSale = ''; })
      .addCase('sale/OpenSaleCompleted', (state) => { state.isClientDetailToSale = ''; })
      .addCase(ClientproductApi.pending, (state, action) => {
        beginClientHistoryRequest(state, action);
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "loading" };
        state.isListViewError = "";
      })
      .addCase(ClientproductApi.fulfilled, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        const previous = state.isListView;
        const isNextPage = previous && previous.current_page < action.payload.current_page;
        state.isListView = isNextPage && Array.isArray(previous.data) && Array.isArray(action.payload.data)
          ? { ...action.payload, data: [...previous.data, ...action.payload.data] }
          : action.payload;
        state.isListViewError = "";
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "succeeded" };
      })
      .addCase(ClientproductApi.rejected, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        state.isListViewError = contentErrorMessage(action, "Unable to load products.");
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, clienttosaleproduct } = clientproductSlice.actions;
export default clientproductSlice.reducer;
